/* global gtag */
import * as Sentry from '@sentry/vue';
import firebase from 'firebase/app';
import 'firebase/auth';
import JourneyPlanner from './components/JourneyPlanner';
import getClientVisibleKey from './Recaptcha';
import UsersAgentUtils from './utilities/UsersAgentUtils';

require('../css/home.scss');

$(() => {
    $('#journey-planner-card.vue-app')
        .makeVueApp({
            components: {
                JourneyPlanner,
            },
            methods: {
                search: (request) => {
                    const usePopups = window.location.search.indexOf('popup') !== -1;
                    window.progressIndicator.start();
                    gtag('event', 'search', {
                        search_term: `${request.requestBody.fromStation} to ${request.requestBody.toStation}`,
                    });
                    let popup = null;
                    if (usePopups) {
                        popup = window.open('about:blank');
                        popup.document.write('Loading&hellip;');
                    }

                    if (!('grecaptcha' in window)) {
                        if (usePopups) {
                            popup.location = '/no-recaptcha';
                        } else {
                            window.location = '/no-recaptcha';
                        }
                        throw new Error('ReCAPTCHA not available (blocked?)');
                    }

                    const requestString = JSON.stringify(request.requestBody);
                    if (request) {
                        window.sessionStorage.setItem('searchParameters', requestString);
                    }
                    // eslint-disable-next-line no-undef
                    grecaptcha.ready(() => {
                        // eslint-disable-next-line no-undef
                        grecaptcha.execute(getClientVisibleKey(), { action: 'submit' })
                            .then((token) => {
                                UsersAgentUtils.getValue()
                                    .then((usersAgent) => {
                                        const headers = new Headers({
                                            'X-CAPTCHA-Token': token,
                                            'Users-Agent': usersAgent,
                                        });
                                        Sentry.addBreadcrumb({
                                            category: 'search',
                                            message: `Search Parameters for current search: ${requestString}`,
                                            level: 'debug',
                                        });
                                        fetch('/search/submit', {
                                            method: 'POST',
                                            body: requestString,
                                            credentials: 'same-origin',
                                            redirect: 'follow',
                                            headers,
                                        })
                                            .then((response) => {
                                                if ('redirected' in response && response.redirected) {
                                                    if (popup !== null) {
                                                        popup.location = response.url;
                                                    } else if (window.location !== window.top.location) {
                                                        window.top.location = response.url;
                                                    } else {
                                                        window.location.href = response.url;
                                                    }
                                                }
                                                window.progressIndicator.stop();
                                            })
                                            .catch((e) => {
                                                window.progressIndicator.stop();
                                                Sentry.captureException(e);
                                            });
                                    });
                            });
                    });
                },
            },
        });

    const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
            if (entry.contentRect.height === 24) {
                entry.target.parentElement.querySelector('.excerpt')
                    .classList
                    .add('one-more-line');
            } else {
                entry.target.parentElement.querySelector('.excerpt')
                    .classList
                    .remove('one-more-line');
            }
        }
    });

    $('.article-lower .title')
        .each((i, el) => {
            resizeObserver.observe(el);
        });

    const embeddable = document.querySelector('#embeddable');

    function watchModal(modalToObserve) {
        const rsModal = new ResizeObserver(() => {
            let clientRects = document.querySelector(`${modalToObserve} > div.modal-dialog, ${modalToObserve} .dropdown`)
                .getClientRects();
            if (clientRects.length === 0) {
                clientRects = document.querySelector('#embeddable')
                    .getClientRects();
            }
            window.top.postMessage({
                height: clientRects[0].height + (28 * 3),
            }, '*');
        });
        rsModal.observe(document.querySelector(`${modalToObserve} > .modal-dialog, ${modalToObserve} .dropdown`));

        const msModal = new MutationObserver(() => {
            window.top.postMessage({
                height: embeddable.getClientRects()[0].height,
            });
        });
        msModal.observe(document.querySelector(modalToObserve), {
            attributes: true,
        });
    }

    if (typeof embeddable !== 'undefined' && embeddable && window.top) {
        const rs = new ResizeObserver((entries) => {
            for (const entry of entries) {
                window.top.postMessage({ height: entry.target.getClientRects()[0].height }, '*');
            }
        });
        rs.observe(embeddable);

        const msPicker = new MutationObserver(() => {
            const picker = document.querySelector('.picker.passenger-picker');

            if (picker.querySelector('.picker-dropdown').style.display !== 'none') {
                const bottomPx = Math.ceil(
                    document.querySelector('.picker.passenger-picker .picker-dropdown')
                        .getClientRects()[0].bottom,
                );
                let existingPadding = parseInt(embeddable.style.paddingBottom, 10);
                // Chrome does stupid stuff here
                if (Number.isNaN(existingPadding)) {
                    existingPadding = 0;
                }
                const embeddableHeight = embeddable.getClientRects()[0].height - existingPadding;
                const diff = bottomPx - embeddableHeight + 18; // 18px for the shadow
                embeddable.style.paddingBottom = `${diff}px`;
                window.top.postMessage({ height: embeddable.getClientRects()[0].height }, '*');
            } else {
                embeddable.style.paddingBottom = '0px';
                window.top.postMessage({ height: embeddable.getClientRects()[0].height }, '*');
            }
        });
        msPicker.observe(document.querySelector('.picker.passenger-picker'), {
            subtree: true,
            childList: true,
            attributes: true,
        });

        const modalToObserve = '#moreOptionsModal';
        watchModal(modalToObserve);
        watchModal('#date-picker-outbound');
        watchModal('#date-picker-return');
    }

    if (document.querySelector('.view-more-posts') !== null) {
        document.querySelector('.view-more-posts')
            .addEventListener('click', (e) => {
                e.preventDefault();
                document.querySelectorAll('.article-card.hide')
                    .forEach((el) => {
                        el.setAttribute('class', 'article-card');
                    });
                document.querySelector('.outer-posts-wrapper').innerHTML = '<a href="/blog">View blog post archives</svg></a>';
            });
    }

    const yearInReviewMeta = document.querySelector('meta[name="year-in-review-cta"]');

    // if .year-in-review-dismiss clicked, put something in localStorage, add d-none to the element
    if (yearInReviewMeta && yearInReviewMeta.content === 'true') {
        document.querySelector('.year-in-review-dismiss').addEventListener('click', (ev) => {
            localStorage.setItem('year-in-review-dismissed', 'true');
            document.querySelector('.year-in-review').classList.add('d-none');
            ev.preventDefault();
        });
    }

    firebase.auth()
        .onAuthStateChanged((user) => {
            const thisHostname = window.location.hostname;
            let isSuitable = thisHostname === 'trainsplit.com'
                || thisHostname === 'tickets.railforums.co.uk'
                || thisHostname === 'localhost';
            // check localStorage for year-in-review-dismissed
            isSuitable = isSuitable && !localStorage.getItem('year-in-review-dismissed')
                && yearInReviewMeta && yearInReviewMeta.content === 'true';
            if (user && isSuitable) {
                user.getIdToken(true)
                    .then((idToken) => {
                        // send POST fetch request with JSON body {"token": idToken}
                        // to /ts-year-in-review
                        const body = JSON.stringify({ token: idToken });
                        fetch('/ts-year-in-review', {
                            method: 'POST',
                            body,
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })
                            .then((response) => {
                                if (response.ok) {
                                    return response.json();
                                }
                                throw new Error('Network response was not ok.');
                            })
                            .then((data) => {
                                // if it starts https://
                                // grab .year-in-review and remove d-none
                                const yearInReview = document.querySelector('.year-in-review');
                                if (data && yearInReview) {
                                    yearInReview.classList.remove('d-none');
                                    // set href on .year-in-review-link
                                    document.querySelector('.year-in-review-link').href = data;
                                }
                            });
                    });
            }
        });
});
